export default {
    props: {
    },
    data() {
        return {
        }
    },
    watch: {
    },
    methods: {
      /**
       * 自定义接口与页面接口统一回调处理主题的函数
       */
      themeInterfaceHandle(resultData,echoDataName){
        let that = this;
        let propData = this.PageSettingData.page.layout.props.compositeAttr;
        let themeDataFiled = propData.themeDataFiled,
        themeDataFunction = propData.themeDataFunction,
        switchThemeValue=resultData;
        if(themeDataFiled){
          let filedExp = themeDataFiled;
          var dataObject = {IDM:window.IDM};
          dataObject[echoDataName] = resultData;
  
          if(filedExp){
            filedExp = echoDataName+(filedExp.startsWiths("[")?"":".")+filedExp;
            switchThemeValue = window.IDM.express.replace.call(this, "@["+filedExp+"]", dataObject);
          }
        }
        if(themeDataFunction&&themeDataFunction.length>0){
          var paramObject = {
                ...that.commonParam(),
                _this:that
              };
            paramObject[echoDataName] = resultData;
          themeDataFunction.forEach(sitem=>{
            try {
              switchThemeValue = window[sitem.name]&&window[sitem.name].call(this,{customParam:sitem.param,...paramObject});
            } catch (error) {
            }
          })
        }
        that.mainPage&&IDM.theme.setCurrentThemeInfo(switchThemeValue);
        that.themeSetObject = switchThemeValue;
      },
        /**
         * 设置更新当前页面的标题
         */
        setCurrentPageTitle(islater){
            //修改页面标题
            document.title = IDM.express.replace(this.PageSettingData.pageBaseInfo.title || IDM.setting.applications.defaultTitle,{IDM:IDM,window,...this.pageInterfaceResultObject});
            //pageDynamicHeadMetaConfig
            if(this.mainPage&&islater&&IDM.setting.applications.pageDynamicHeadMetaConfig&&IDM.setting.applications.pageDynamicHeadMetaConfig.length){
              try {
                for (let index = 0; index < IDM.setting.applications.pageDynamicHeadMetaConfig.length; index++) {
                  const item = IDM.setting.applications.pageDynamicHeadMetaConfig[index];
                  var meta = document.createElement("meta");
                  Object.keys(item).forEach(key=>{
                    let value = IDM.express.replace(item[key],{IDM:IDM,window,...this.pageInterfaceResultObject});
                    meta.setAttribute(key,value);
                  })
                  document.head.appendChild(meta);
                }
              } catch (error) {
                console.error(error);
              }
            }
        },
        /**
         * svg组件属性处理函数
         * @param {*} moduleDom 
         * @param {*} comObject 
         */
        svgComponentPropsHandle(moduleDom,comObject){
          let that = this;
          let propData = comObject&&comObject.props.compositeAttr?comObject.props.compositeAttr:{};
          moduleDom.attr("title",propData.title);
          //点击事件
          moduleDom.bind("click", function (e) {
            that.commonCustomEventFunHandle(propData,"clickFunction");
          })
        },
        /**
         * 通用自定义函数
         * @param {*} propData 
         * @param {*} name 
         * @param {*} paramObject 
         * @returns 
         */
        commonCustomEventFunHandle(propData,name,paramObject){
          let that = this;
          propData = propData||this.pagePropData;
          var customHandle = propData[name],resultData;
          let paramData = {
            ...that.commonParam(),
            _this: that,
          };
          if(paramObject){
            paramData={
              ...paramData,
              ...paramObject
            }
          }
          customHandle &&
            customHandle.forEach((item) => {
              resultData = window[item.name] &&
                window[item.name].call(this, {
                  ...paramData,
                  customParam: item.param
                });
            });
          return resultData
        },
        /**
         * 通用的url参数对象
         * 所有地址的url参数转换
         */
        commonParam(){
          let urlObject = IDM.url.queryObject();
          var params = {
            pageId:
              window.IDM.broadcast && window.IDM.broadcast.pageModule
                ? window.IDM.broadcast.pageModule.id
                : "",
            urlData: JSON.stringify(urlObject),
          };
          return params;
        },
        /**
         * 组件通信：发送消息的方法
         * @param {
         *  type:"自己定义的，统一规定的type：linkageResult（组件联动传结果值）、linkageDemand（组件联动传需求值）、linkageReload（联动组件重新加载）
         * 、linkageOpenDialog（打开弹窗）、linkageCloseDialog（关闭弹窗）、linkageShowModule（显示组件）、linkageHideModule（隐藏组件）、linkageResetDefaultValue（重置默认值）"
         *  message:{实际的消息对象},
         *  rangeModule:"为空发送给全部，根据配置的属性中设定的值（值的内容是组件的packageid数组），不取子表的，比如直接 this.$root.propData.compositeAttr["attrKey"]（注意attrKey是属性中定义的bindKey）,这里的格式为：['1','2']"",
         *  className:"指定的组件类型，比如只给待办组件发送，然后再去过滤上面的值"
         *  globalSend:如果为true则全站发送消息，注意全站rangeModule是无效的，只有className才有效，默认为false
         * } object 
         */
        sendBroadcastMessage(object,routerId){
            window.IDM.broadcast&&window.IDM.broadcast.send(object,routerId||"");
        },
        /**
         * 保存时候删除的不必要的属性
         */
        deleteLayoutAttachAttr(module) {
          if (!(module instanceof Array)) {
            module = [module];
          }
          module.forEach((item) => {
            delete item.env;
            delete item.hasLoading;
            delete item.loaded;
            delete item.loading;
            delete item.moduleReload;
            delete item.mountComplete;
            delete item.props;
            delete item.routerId;
            if (item.children && item.children.length > 0) {
              this.deleteLayoutAttachAttr(item.children);
            }
          });
        }
    },
    mounted() {
    },
}
